import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {isAuth} from './helpers';

const PrivateRoute = ({ children, ...rest }) => {
    return (
      <Route
        {...rest}
        render={({ location }) =>
          isAuth() ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/auth/signin",
                state: { from: location }
              }}
            />
          )
        }
      />
    );
  }

  export default PrivateRoute;